import { Button, Container } from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer-wrapper">
      <Container className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 text-center md:text-left">
              <img
                src="/assets/images/logo.png"
                alt="Logo"
                className="footer-logo"
              />
            </div>
            <div className="col-md-4 text-center">
              <Button
                href="/Contact"
                variant="outline-dark"
                className="footer-btn"
              >
                Contact Us
              </Button>
            </div>
            <div className="col-md-4 footer-email">
              <FaEnvelope className="mr-2" />
              <span>tarsemrattu@gmail.com</span>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
